module.exports = __webpack_public_path__ + "static/img/70 (3).3fb8367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/70 (3).jpg
// module id = IQfS
// module chunks = 0